import { useSizeAndWidthContext } from '../../../context';
import { PdpActionLink } from '../pdpActionLink/PdpActionLink';

export function EmailMeWhenInStockLink() {
  const { selectedSku, setError, selectedSize, selectedWidth } = useSizeAndWidthContext();

  const handleEmailMeWhenInStock = () => {
    if (!selectedSku) {
      setError([...(!selectedSize ? ['size'] : []), ...(!selectedWidth ? ['width'] : [])]);
    }
  };
  return (
    <PdpActionLink onClick={handleEmailMeWhenInStock} testId="emailMeWhenInStockButton" type="emailMeWhenInStock" />
  );
}
